module.exports = __webpack_public_path__ + "img/logo_03.104f66fd.png";